import { useId } from 'react'
import { observer } from 'mobx-react-lite'
import { TransactionsTable } from '@/features/billing/transactions/TransactionsTable'
import type { JobBillingDetailsViewModel } from '@/features/jobs/details/JobBillingDetailsViewModel'
import { SectionHeadline } from '@/components/SectionHeadline'
import {
  Card,
  CardContent,
  CardContentDecoration,
  CardSubtitle,
  CardTitle,
} from '@/components/Card'
import { Icon } from '@/components/Icon'

interface BillingPaymentHistorySectionContainerProps {
  vm: JobBillingDetailsViewModel
}

interface PaymentHistoryEmptyProps {
  testId?: string
}

/**
 * The PaymentHistoryEmpty
 */
export function PaymentHistoryEmpty({ testId }: PaymentHistoryEmptyProps) {
  return (
    <Card testId={testId}>
      <CardContent>
        <CardContentDecoration>
          <Icon name="card" variant="surface-background" />
        </CardContentDecoration>
        <CardTitle>No transactions yet</CardTitle>
        <CardSubtitle>All charges for this job will show up here.</CardSubtitle>
      </CardContent>
    </Card>
  )
}

/**
 * The BillingPaymentHistorySectionContainer
 */
export const BillingPaymentHistorySectionContainer = observer(
  ({ vm }: BillingPaymentHistorySectionContainerProps) => {
    const transactionsHeadlineId = useId()

    return (
      <>
        <SectionHeadline id={transactionsHeadlineId}>
          Payment history
        </SectionHeadline>

        {vm.transactionTableVm.isEmpty &&
        !vm.transactionTableVm.scrollProvider.fetch.pending ? (
          <PaymentHistoryEmpty />
        ) : (
          <TransactionsTable
            skeletonColor="secondary"
            aria-labelledby={transactionsHeadlineId}
            vm={vm.transactionTableVm}
          />
        )}
      </>
    )
  },
)
